import { createApp, ref, onMounted } from 'vue'

const app = createApp({
  setup() {
    const accordionStatements = ref<boolean[]>([])
    const accordionNestedStatements = ref<boolean[]>([])
    onMounted(() => {
      const accordions = document.querySelectorAll('.c-accordion:not(.c-accordion--nested)')
      const nestedAccordions = document.querySelectorAll('.c-accordion--nested')

      accordions.forEach((accordion, index) => {
        accordionStatements.value[index] = false
      })

      nestedAccordions.forEach((accordion, index) => {
        accordionNestedStatements.value[index] = false
      })
    })
    const toggleStatement = (number: number) => {
      accordionStatements.value[number] = !accordionStatements.value[number]
    }

    const toggleNestedStatement = (number: number) => {
      accordionNestedStatements.value[number] = !accordionNestedStatements.value[number]
    }
    return { accordionStatements, toggleStatement, accordionNestedStatements, toggleNestedStatement }
  }
})
if (document.getElementById('accordionControl') != null) {
  app.mount('#accordionControl')
}